module.exports = __webpack_public_path__ + "static/media/cico-logo.50f2ff72.svg";